module.exports = __webpack_public_path__ + "name=img/src/assets/img_quote.svg?a9141d6cbfc9129c8994d50c45432fb7";